import { Grid, IconButton, Typography } from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import { observer } from "mobx-react";
import React from "react";
import theme from "Theme/AppTheme";
import { useStore } from "utils/useStore";
import { AgentLogoWithNameFull } from "./Branding/AgentLogoWithNameFull";
import AgentStore from "./Stores/AgentStore";
import CloseIcon from "@mui/icons-material/Close";
import KboTeaserBackground from "../../kboTeaserBackground.svg";

export const AgentTeaserDrawerContents = observer(() => {
    const agentStore = useStore(AgentStore);

    return (
        <Grid
            container
            width="calc(max(20dvw, 372px))"
            height="100%"
            justifyContent="center"
            alignItems="center"
            direction="column"
            flexWrap="nowrap"
            rowGap={1}
            p={2}
            sx={{
                position: "relative",
                backgroundImage: `url(${KboTeaserBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <IconButton
                onClick={() => agentStore.closeDrawer()}
                size="small"
                id="kbo-close-button"
                sx={(theme) => ({
                    right: theme.spacing(2),
                    top: theme.spacing(2),
                    position: "absolute",
                    zIndex: theme.zIndex.appBar,
                })}
            >
                <CloseIcon style={{ color: theme.palette.gray[400] }} />
            </IconButton>
            <Grid item>
                <BeautifulTeaserGraphic />
            </Grid>
            <Grid
                container
                item
                width="fit-content"
                direction="row"
                alignItems="center"
                columnGap={1}
                flexWrap="nowrap"
            >
                <Grid item>
                    <Typography
                        fontSize="20px"
                        fontWeight={600}
                        lineHeight="32px"
                    >
                        Unlock insights with
                    </Typography>
                </Grid>
                <Grid item>
                    <AgentLogoWithNameFull width="71" height="24" />
                </Grid>
            </Grid>
            <Grid item>
                <Typography
                    textAlign="center"
                    color="gray.700"
                    fontSize="13px"
                    lineHeight="20px"
                >
                    {agentStore.kboStatus.organization.isActive
                        ? "To see deeper analysis with cited examples, request access to our AI assistant, KBo."
                        : "To see deeper analysis with cited examples, talk to your contact at Authenticx about our AI assistant, KBo."}
                </Typography>
            </Grid>
            <Grid item mt={1}>
                <AcxButton
                    loading={agentStore.getTaskLoading(
                        AgentStore.Tasks.RequestAccess,
                    )}
                    disabled={agentStore.isAccessRequested}
                    onClick={() => agentStore.requestAccess()}
                >
                    {agentStore.isAccessRequested
                        ? "We'll be in touch shortly!"
                        : "Request Access to KBo"}
                </AcxButton>
            </Grid>
        </Grid>
    );
});

function BeautifulTeaserGraphic() {
    return (
        <svg
            width="249"
            height="224"
            viewBox="0 0 249 224"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_24823_5825)">
                <rect
                    x="16.5"
                    y="56.5"
                    width="159"
                    height="147"
                    rx="8"
                    fill="white"
                />
                <rect
                    x="27.5"
                    y="69.5"
                    width="16"
                    height="16"
                    rx="4"
                    fill="url(#paint0_linear_24823_5825)"
                />
                <rect
                    x="48.0293"
                    y="73.5"
                    width="32"
                    height="8"
                    rx="2.58824"
                    fill="url(#paint1_linear_24823_5825)"
                />
                <rect
                    x="84.5586"
                    y="73.5"
                    width="55"
                    height="8"
                    rx="2.58824"
                    fill="url(#paint2_linear_24823_5825)"
                />
                <path
                    d="M71.5 96.5C71.5 94.2909 73.2909 92.5 75.5 92.5H143.5C145.709 92.5 147.5 94.2909 147.5 96.5V112.5H75.5C73.2909 112.5 71.5 110.709 71.5 108.5V96.5Z"
                    fill="url(#paint3_linear_24823_5825)"
                />
                <rect
                    x="152.029"
                    y="100.5"
                    width="12"
                    height="12"
                    rx="6"
                    fill="url(#paint4_linear_24823_5825)"
                />
                <rect
                    x="27.5"
                    y="176.863"
                    width="12"
                    height="12"
                    rx="6"
                    fill="url(#paint5_linear_24823_5825)"
                />
                <rect
                    x="44.0293"
                    y="175.016"
                    width="15.4545"
                    height="5.15152"
                    rx="2.57576"
                    fill="url(#paint6_linear_24823_5825)"
                />
                <rect
                    x="61.5444"
                    y="175.016"
                    width="27.8182"
                    height="5.15152"
                    rx="2.57576"
                    fill="url(#paint7_linear_24823_5825)"
                />
                <rect
                    x="91.4233"
                    y="175.016"
                    width="8.24242"
                    height="5.15152"
                    rx="2.57576"
                    fill="url(#paint8_linear_24823_5825)"
                />
                <rect
                    x="44.0293"
                    y="183.197"
                    width="19.5758"
                    height="5.15152"
                    rx="2.57576"
                    fill="url(#paint9_linear_24823_5825)"
                />
                <rect
                    x="65.6655"
                    y="183.197"
                    width="23.697"
                    height="5.15152"
                    rx="2.57576"
                    fill="url(#paint10_linear_24823_5825)"
                />
                <rect
                    x="91.4233"
                    y="183.197"
                    width="26.7879"
                    height="5.15152"
                    rx="2.57576"
                    fill="url(#paint11_linear_24823_5825)"
                />
                <path
                    d="M35.9619 165.549C36.2185 165.255 36.6631 165.226 36.9551 165.484C37.1972 165.699 37.2548 166.042 37.1221 166.321C36.3063 166.945 35.328 167.362 34.2617 167.498L35.9619 165.549ZM32.8398 165.171C33.0964 164.877 33.541 164.848 33.833 165.106C34.1249 165.365 34.1537 165.812 33.8975 166.106L32.6885 167.492C32.1596 167.42 31.6526 167.28 31.1768 167.078L32.8398 165.171ZM32.0645 162.101C32.3209 161.806 32.7655 161.778 33.0576 162.036C33.3497 162.295 33.3786 162.743 33.1221 163.037L30.1104 166.491C29.7216 166.223 29.3652 165.91 29.0498 165.559L32.0645 162.101ZM39.5 161.503C39.5 162.629 39.1926 163.683 38.6602 164.586C38.3985 164.815 38.0052 164.824 37.7373 164.587C37.4452 164.328 37.4164 163.88 37.6729 163.586L39.499 161.489C39.499 161.494 39.5 161.498 39.5 161.503ZM28.7959 161.891C29.0523 161.597 29.497 161.568 29.7891 161.826C30.0811 162.085 30.11 162.533 29.8535 162.827L28.332 164.572C28.069 164.124 27.8613 163.638 27.7197 163.125L28.7959 161.891ZM38.6855 158.464C38.9465 158.915 39.1513 159.402 39.29 159.918L35.6084 164.144C35.3519 164.438 34.9073 164.467 34.6152 164.209C34.3232 163.951 34.2944 163.502 34.5508 163.208L38.6855 158.464ZM27.501 161.565C27.5008 161.545 27.5 161.524 27.5 161.503C27.5002 158.407 29.8097 155.857 32.7871 155.502L27.501 161.565ZM36.916 156.534C37.3034 156.805 37.6571 157.121 37.9707 157.474L34.834 161.073C34.5775 161.368 34.1319 161.397 33.8398 161.139C33.5479 160.88 33.5192 160.432 33.7754 160.138L36.916 156.534ZM34.3496 155.519C34.8763 155.594 35.3811 155.738 35.8545 155.941L31.5654 160.864C31.3089 161.159 30.8634 161.187 30.5713 160.929C30.2795 160.67 30.2514 160.222 30.5078 159.928L34.3496 155.519Z"
                    fill="url(#paint12_linear_24823_5825)"
                />
                <path
                    d="M145.029 123.5C145.029 121.291 143.238 119.5 141.029 119.5H48.0293C45.8202 119.5 44.0293 121.291 44.0293 123.5V167.5H141.029C143.238 167.5 145.029 165.709 145.029 163.5V123.5Z"
                    fill="url(#paint13_linear_24823_5825)"
                />
                <rect
                    x="51.0293"
                    y="127.016"
                    width="29.8788"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
                <rect
                    x="82.9688"
                    y="127.016"
                    width="14.4242"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
                <rect
                    x="99.4536"
                    y="127.016"
                    width="37.0909"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
                <rect
                    x="51.0293"
                    y="145.562"
                    width="15.4545"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
                <rect
                    x="68.5444"
                    y="145.562"
                    width="27.8182"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
                <rect
                    x="98.4233"
                    y="145.562"
                    width="8.24242"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
                <rect
                    x="51.0293"
                    y="136.288"
                    width="19.5758"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
                <rect
                    x="72.6655"
                    y="136.288"
                    width="23.697"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
                <rect
                    x="98.4233"
                    y="136.288"
                    width="26.7879"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
                <rect
                    x="51.0293"
                    y="154.833"
                    width="19.5758"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
                <rect
                    x="72.6655"
                    y="154.833"
                    width="23.697"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
                <rect
                    x="98.4233"
                    y="154.833"
                    width="26.7879"
                    height="5.15152"
                    rx="2.57576"
                    fill="#BFDBFE"
                />
            </g>
            <g filter="url(#filter1_di_24823_5825)">
                <g clipPath="url(#clip0_24823_5825)">
                    <rect
                        opacity="0.6"
                        x="143.25"
                        y="9.5"
                        width="90"
                        height="77"
                        fill="url(#paint14_linear_24823_5825)"
                    />
                    <rect
                        opacity="0.8"
                        x="143.25"
                        y="9.5"
                        width="90"
                        height="77"
                        fill="url(#paint15_linear_24823_5825)"
                    />
                    <rect
                        x="151.75"
                        y="39.5156"
                        width="15.4545"
                        height="5.15152"
                        rx="2.57576"
                        fill="url(#paint16_linear_24823_5825)"
                        fillOpacity="0.7"
                    />
                    <rect
                        x="169.265"
                        y="39.5156"
                        width="27.8182"
                        height="5.15152"
                        rx="2.57576"
                        fill="url(#paint17_linear_24823_5825)"
                        fillOpacity="0.7"
                    />
                    <rect
                        x="199.144"
                        y="39.5156"
                        width="8.24242"
                        height="5.15152"
                        rx="2.57576"
                        fill="url(#paint18_linear_24823_5825)"
                        fillOpacity="0.7"
                    />
                    <rect
                        x="151.75"
                        y="47.6973"
                        width="19.5758"
                        height="5.15152"
                        rx="2.57576"
                        fill="url(#paint19_linear_24823_5825)"
                        fillOpacity="0.7"
                    />
                    <rect
                        x="173.386"
                        y="47.6973"
                        width="23.697"
                        height="5.15152"
                        rx="2.57576"
                        fill="url(#paint20_linear_24823_5825)"
                        fillOpacity="0.7"
                    />
                    <rect
                        x="199.144"
                        y="47.6973"
                        width="26.7879"
                        height="5.15152"
                        rx="2.57576"
                        fill="url(#paint21_linear_24823_5825)"
                        fillOpacity="0.7"
                    />
                    <rect
                        x="151.75"
                        y="55.9541"
                        width="29"
                        height="5"
                        rx="2.5"
                        fill="url(#paint22_linear_24823_5825)"
                        fillOpacity="0.7"
                    />
                    <rect
                        x="182.811"
                        y="55.9541"
                        width="20"
                        height="5"
                        rx="2.5"
                        fill="url(#paint23_linear_24823_5825)"
                        fillOpacity="0.7"
                    />
                    <rect
                        x="204.871"
                        y="55.9541"
                        width="14"
                        height="5"
                        rx="2.5"
                        fill="url(#paint24_linear_24823_5825)"
                        fillOpacity="0.7"
                    />
                    <g filter="url(#filter2_d_24823_5825)">
                        <rect
                            x="151.75"
                            y="66"
                            width="51.2274"
                            height="9.40918"
                            rx="4"
                            fill="url(#paint25_linear_24823_5825)"
                            shapeRendering="crispEdges"
                        />
                        <path
                            d="M160.847 68.7441H163.983M163.983 68.7441V71.8805M163.983 68.7441L160.847 71.8805L159.279 70.3123L156.926 72.6646"
                            stroke="#F0F1F4"
                            strokeOpacity="0.7"
                            strokeWidth="1.17615"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <rect
                            x="169.159"
                            y="68.1289"
                            width="27.8182"
                            height="5.15152"
                            rx="2.57576"
                            fill="#F0F1F4"
                            fillOpacity="0.7"
                        />
                    </g>
                    <path
                        d="M159.75 21.333C156.07 21.333 153.083 24.3197 153.083 27.9997C153.083 31.6797 156.07 34.6663 159.75 34.6663C163.43 34.6663 166.417 31.6797 166.417 27.9997C166.417 24.3197 163.43 21.333 159.75 21.333ZM159.75 23.9997C161.037 23.9997 162.083 25.0463 162.083 26.333C162.083 27.6197 161.037 28.6663 159.75 28.6663C158.463 28.6663 157.417 27.6197 157.417 26.333C157.417 25.0463 158.463 23.9997 159.75 23.9997ZM159.75 33.333C158.397 33.333 156.797 32.7863 155.657 31.413C156.783 30.533 158.203 29.9997 159.75 29.9997C161.297 29.9997 162.717 30.533 163.843 31.413C162.703 32.7863 161.103 33.333 159.75 33.333Z"
                        fill="url(#paint26_linear_24823_5825)"
                        fillOpacity="0.7"
                    />
                </g>
                <rect
                    x="144.25"
                    y="10.5"
                    width="89"
                    height="75"
                    rx="7.5"
                    stroke="url(#paint27_linear_24823_5825)"
                />
            </g>
            <g filter="url(#filter3_d_24823_5825)">
                <path
                    d="M44.5956 30.3334L46.4061 26.323L50.4165 24.5126C51.3102 24.1001 51.3102 22.8396 50.4165 22.4271L46.4061 20.6167L44.5956 16.5834C44.1831 15.6896 42.9227 15.6896 42.5102 16.5834L40.6998 20.5938L36.6665 22.4042C35.7727 22.8167 35.7727 24.0771 36.6665 24.4896L40.6769 26.3001L42.4873 30.3334C42.8998 31.2271 44.1831 31.2271 44.5956 30.3334ZM26.354 33.7709L22.7102 25.7501C21.9081 23.9626 19.3415 23.9626 18.5394 25.7501L14.8956 33.7709L6.8748 37.4146C5.0873 38.2396 5.0873 40.7834 6.8748 41.5855L14.8956 45.2292L18.5394 53.2501C19.3644 55.0376 21.9081 55.0376 22.7102 53.2501L26.354 45.2292L34.3748 41.5855C36.1623 40.7605 36.1623 38.2167 34.3748 37.4146L26.354 33.7709ZM42.4873 48.6667L40.6769 52.6771L36.6665 54.4876C35.7727 54.9001 35.7727 56.1605 36.6665 56.573L40.6769 58.3834L42.4873 62.4167C42.8998 63.3105 44.1602 63.3105 44.5727 62.4167L46.3831 58.4063L50.4165 56.5959C51.3102 56.1834 51.3102 54.923 50.4165 54.5105L46.4061 52.7001L44.5956 48.6667C44.1831 47.773 42.8998 47.773 42.4873 48.6667Z"
                    fill="url(#paint28_linear_24823_5825)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_24823_5825"
                    x="1.5"
                    y="46.5"
                    width="189"
                    height="177"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="5" />
                    <feGaussianBlur stdDeviation="7.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_24823_5825"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_24823_5825"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_di_24823_5825"
                    x="128.75"
                    y="0"
                    width="120"
                    height="106"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="5" />
                    <feGaussianBlur stdDeviation="7.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_24823_5825"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_24823_5825"
                        result="shape"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect2_innerShadow_24823_5825"
                    />
                </filter>
                <filter
                    id="filter2_d_24823_5825"
                    x="147.75"
                    y="64"
                    width="59.2275"
                    height="17.4092"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_24823_5825"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_24823_5825"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter3_d_24823_5825"
                    x="3.53418"
                    y="13.9131"
                    width="49.5527"
                    height="51.1738"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.2 0 0 0 0 0.745098 0 0 0 0 0.741176 0 0 0 0.8 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_24823_5825"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_24823_5825"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_24823_5825"
                    x1="27.5"
                    y1="77.5"
                    x2="43.5"
                    y2="77.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F3F4F6" />
                    <stop offset="1" stopColor="#E5E7EB" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_24823_5825"
                    x1="48.0293"
                    y1="77.5"
                    x2="80.0293"
                    y2="77.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F3F4F6" />
                    <stop offset="1" stopColor="#E5E7EB" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_24823_5825"
                    x1="84.5586"
                    y1="77.5"
                    x2="139.559"
                    y2="77.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F3F4F6" />
                    <stop offset="1" stopColor="#E5E7EB" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_24823_5825"
                    x1="71.5"
                    y1="102.5"
                    x2="147.5"
                    y2="102.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F3F4F6" />
                    <stop offset="1" stopColor="#E5E7EB" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_24823_5825"
                    x1="152.029"
                    y1="106.5"
                    x2="164.029"
                    y2="106.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F3F4F6" />
                    <stop offset="1" stopColor="#E5E7EB" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_24823_5825"
                    x1="27.5"
                    y1="182.863"
                    x2="39.5"
                    y2="182.863"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F3F4F6" />
                    <stop offset="1" stopColor="#E5E7EB" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_24823_5825"
                    x1="44.0293"
                    y1="177.591"
                    x2="59.4838"
                    y2="177.591"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_24823_5825"
                    x1="61.5444"
                    y1="177.591"
                    x2="89.3626"
                    y2="177.591"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_24823_5825"
                    x1="91.4233"
                    y1="177.591"
                    x2="99.6658"
                    y2="177.591"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint9_linear_24823_5825"
                    x1="44.0293"
                    y1="185.773"
                    x2="63.6051"
                    y2="185.773"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint10_linear_24823_5825"
                    x1="65.6655"
                    y1="185.773"
                    x2="89.3625"
                    y2="185.773"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint11_linear_24823_5825"
                    x1="91.4233"
                    y1="185.773"
                    x2="118.211"
                    y2="185.773"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint12_linear_24823_5825"
                    x1="27.8559"
                    y1="155.976"
                    x2="40.2369"
                    y2="166.78"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32D1B7" />
                    <stop offset="0.695" stopColor="#349BC7" />
                    <stop offset="1.0001" stopColor="#3664D6" />
                </linearGradient>
                <linearGradient
                    id="paint13_linear_24823_5825"
                    x1="142.034"
                    y1="121.398"
                    x2="100.022"
                    y2="198.511"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32D1B7" />
                    <stop offset="0.695" stopColor="#349BC7" />
                    <stop offset="1.0001" stopColor="#3664D6" />
                </linearGradient>
                <linearGradient
                    id="paint14_linear_24823_5825"
                    x1="163.361"
                    y1="-1.62892"
                    x2="275.087"
                    y2="9.72638"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#1D2A60" />
                    <stop offset="1" stopColor="#239C98" />
                </linearGradient>
                <linearGradient
                    id="paint15_linear_24823_5825"
                    x1="145.919"
                    y1="12.5442"
                    x2="226.114"
                    y2="94.3112"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32D1B7" />
                    <stop offset="0.695" stopColor="#349BC7" />
                    <stop offset="1.0001" stopColor="#3664D6" />
                </linearGradient>
                <linearGradient
                    id="paint16_linear_24823_5825"
                    x1="151.75"
                    y1="42.0914"
                    x2="167.205"
                    y2="42.0914"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint17_linear_24823_5825"
                    x1="169.265"
                    y1="42.0914"
                    x2="197.083"
                    y2="42.0914"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint18_linear_24823_5825"
                    x1="199.144"
                    y1="42.0914"
                    x2="207.386"
                    y2="42.0914"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint19_linear_24823_5825"
                    x1="151.75"
                    y1="50.273"
                    x2="171.326"
                    y2="50.273"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint20_linear_24823_5825"
                    x1="173.386"
                    y1="50.273"
                    x2="197.083"
                    y2="50.273"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint21_linear_24823_5825"
                    x1="199.144"
                    y1="50.273"
                    x2="225.932"
                    y2="50.273"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint22_linear_24823_5825"
                    x1="151.75"
                    y1="58.4541"
                    x2="180.75"
                    y2="58.4541"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint23_linear_24823_5825"
                    x1="182.811"
                    y1="58.4541"
                    x2="202.811"
                    y2="58.4541"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint24_linear_24823_5825"
                    x1="204.871"
                    y1="58.4541"
                    x2="218.871"
                    y2="58.4541"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint25_linear_24823_5825"
                    x1="153.269"
                    y1="66.372"
                    x2="157.222"
                    y2="85.1425"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32D1B7" />
                    <stop offset="0.695" stopColor="#349BC7" />
                    <stop offset="1.0001" stopColor="#3664D6" />
                </linearGradient>
                <linearGradient
                    id="paint26_linear_24823_5825"
                    x1="159.75"
                    y1="21.333"
                    x2="159.75"
                    y2="34.6663"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F1F4" />
                    <stop offset="1" stopColor="#E7E9ED" />
                </linearGradient>
                <linearGradient
                    id="paint27_linear_24823_5825"
                    x1="146.419"
                    y1="13.0047"
                    x2="225.545"
                    y2="94.7439"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32D1B7" />
                    <stop offset="0.695" stopColor="#349BC7" />
                    <stop offset="1.0001" stopColor="#3664D6" />
                </linearGradient>
                <linearGradient
                    id="paint28_linear_24823_5825"
                    x1="6.88532"
                    y1="17.7781"
                    x2="55.311"
                    y2="58.5697"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32D1B7" />
                    <stop offset="0.695" stopColor="#349BC7" />
                    <stop offset="1.0001" stopColor="#3664D6" />
                </linearGradient>
                <clipPath id="clip0_24823_5825">
                    <rect
                        x="143.75"
                        y="10"
                        width="90"
                        height="76"
                        rx="8"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
